import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import axios from '../axios';
import * as actions from '../store/actions/index';

class Logs extends Component {
    state = {
        redirect: false,
    };
    componentDidMount() {
        const token = 'Bearer ' + localStorage.getItem('token');
        axios.get(`http://localhost:7000/admin/checkadmin`, {headers: {"Authorization": token}})
            .then(({data}) => {
                if (data.status === 1) {
                    this.setState({
                        redirect: false
                    })
                } else {
                    this.setState({
                        redirect: true
                    })
                }
            })
            .catch(err => {
                console.log(err)
            });

        this.props.fetchLoginLogs();

    }


    render() {
        console.log(this.props.loginLogs);
        let logs = null;
        logs = this.props.loginLogs.map((logs, index) => {
            return (
                <tr>
                    <th scope="row">{index}</th>
                    <td>{logs.email}</td>
                    <td>{logs.date}</td>
                    <td>{logs.ip}</td>
                    <td>{logs.so}</td>
                    <td>{logs.browser}</td>
                </tr>
            )
        });
        if (this.state.redirect) {
            return <Redirect to="/"/>
        }
        return (
            <div className="container col-12 mt-6 mr-0 ml-0">
                <table className="table-responsive">
                    <thead>
                    <tr>
                        <th scope="col" className="text-primary">#</th>
                        <th scope="col" className="text-primary">Email</th>
                        <th scope="col" className="text-primary">Data</th>
                        <th scope="col" className="text-primary">IP</th>
                        <th scope="col" className="text-primary">Sistema Operativo</th>
                        <th scope="col" className="text-primary">Browser</th>
                    </tr>
                    </thead>
                    <tbody>
                    {logs}
                    </tbody>
                </table>
                <button type="button" className="btn btn-dark" onClick={this.props.history.goBack}>Voltar atrás</button>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        loginLogs: state.admin.loginLogs
    }
};

const mapDispatchToProps = dispatch => {
    return {
        fetchLoginLogs: () => dispatch(actions.loginLogs())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Logs);



// WEBPACK FOOTER //
// ./src/containers/logs.js